"use strict";

require("core-js/modules/es6.number.constructor.js");

module.exports = function (value) {
  value = Number(value);
  if (isNaN(value) || value === 0) return value;
  return value > 0 ? 1 : -1;
};